import { atom } from 'jotai';

import type { ConversationListRow } from '@ekhodealer/ekho-common';

/** Selected conversation — shared across Conversation components */
export const selectedConversationAtom = atom<ConversationListRow | null>(null);
